<template>
  <div class="content">
    <div class="member-shop">
      <div :class="`info-card member-0${userLevel}`">
        <div class="info-left l fix" v-if="isMember">
          <div class="user-level l fix">
            <i :class="`icon icon-member icon-member-0${userLevel} l`"></i>
            <div class="rank-text l">
              <div class="wel-text">尊敬的：{{ customerInfo.fullName }}</div>
              <h3>{{ customerInfo.userLevel }}</h3>
            </div>
          </div>
          <div class="user-points l">
            <div class="integral fix">
              <i class="icon icon-integral l"></i>
              <span class="text l">有效积分</span>
              <span class="num l">{{ customerInfo.userPoint }}</span>
            </div>
            <div class="btn-box fix">
              <a
                :class="`btn-item btn-integral ${signInFlag} l`"
                @click="signIn"
                href="javascript: void(0)"
                >{{signInFlag==='cur'?`已连续签到${continuousSigInDays}天`:'每日签到'}}</a
              >
              <div class="e-vip l" v-if="customerInfo.infoIntegrity < 100">
                <a
                  class="btn-item btn-vip"
                  href="/Rccl.UserCenter/CustomerInfo/editInfo"
                  >完善信息领取<span class="cur"><i>200</i>积分</span></a
                >
              </div>
            </div>
            <div
              class="sign-in-layer"
              v-if="isSignIn"
              @click.self="closeSignIn"
            >
              <div class="sign-in">
                <p>签到成功</p>
                <h3>
                  <span class="cur"><i>+</i>{{ obtainPoint }}</span
                  >积分
                </h3>
                <a
                  class="btn-item btn-close"
                  @click="closeSignIn"
                  href="javascript: void(0)"
                ></a>
              </div>
            </div>
          </div>
        </div>
        <div class="info-left person-info l fix" v-else>
          <div class="user-level l fix">
            <i :class="`icon icon-member icon-member-00 l`"></i>
            <div class="rank-text l">
              <div class="wel-text">尊敬的：{{ customerInfo.fullName }}</div>
              <div class="integral fix">
                <i class="icon icon-integral l"></i>
                <span class="text l">有效积分</span>
                <span class="num l">{{ customerInfo.userPoint }}</span>
              </div>
            </div>
          </div>
          <div class="member-tip l fix">
            <a class="btn-item btn-join l" href="javascript: void(0)"
              >立即入会</a
            >
            <div class="join-tip l">
              <p>赠<span class="cur">50美金</span>船上消费金</p>
              <p>及<span class="cur">100积分</span>奖励</p>
            </div>
          </div>
        </div>
        <div class="link-aside r">
          <router-link
            tag="a"
            class="link-item link-integral"
            to="/member/shop/integral"
            ><span>积分明细</span><i class="icon icon-list"></i
          ></router-link>
          <router-link
            tag="a"
            class="link-item link-gift"
            to="/member/shop/gift"
            ><span>我的礼品</span><i class="icon icon-gift"></i
          ></router-link>
        </div>
      </div>
      <!-- shop-rec -->
      <div class="part-shop">
        <ShopRec :rec="shopRec">
          <h3 slot="titleText">爆款推荐</h3>
        </ShopRec>
      </div>
      <!-- rec-banner -->
      <div class="part-rec">
        <SingleBanner :bannerList="bannerList"></SingleBanner>
      </div>
      <!-- pro -->
      <div class="part-pro">
        <div class="pro-select-wrap">
          <div class="pro-select" v-bind:class="{ fixed: isFixed }">
            <ul class="sort-type fix">
              <li
                :class="`${typeActiveIndex === 0 ? 'cur' : ''}`"
                @click="changeType({ typeActiveIndex: 0 })"
              >
                全部礼品
              </li>
              <li
                :class="`${typeActiveIndex === 1 ? 'cur' : ''}`"
                @click="changeType({ typeActiveIndex: 1, GiftType: 20 })"
              >
                实物礼品
              </li>
              <li
                :class="`${typeActiveIndex === 2 ? 'cur' : ''}`"
                @click="changeType({ typeActiveIndex: 2, GiftType: 10 })"
              >
                电子礼品
              </li>
              <li
                :class="`${typeActiveIndex === 3 ? 'cur' : ''}`"
                @click="changeType({ typeActiveIndex: 3, GiftType: 30 })"
              >
                优惠券
              </li>
            </ul>
            <ul class="sort-integral fix">
              <li
                :class="`${rangeActiveIndex === 0 ? 'cur' : ''}`"
                @click="changeRange({ rangeActiveIndex: 0 })"
              >
                全部积分
              </li>
              <li
                :class="`${rangeActiveIndex === 1 ? 'cur' : ''}`"
                @click="
                  changeRange({
                    rangeActiveIndex: 1,
                    PriceBegin: 0,
                    PriceEnd: 5000,
                  })
                "
              >
                0-5K
              </li>
              <li
                :class="`${rangeActiveIndex === 2 ? 'cur' : ''}`"
                @click="
                  changeRange({
                    rangeActiveIndex: 2,
                    PriceBegin: 5000,
                    PriceEnd: 10000,
                  })
                "
              >
                5K-10K
              </li>
              <li
                :class="`${rangeActiveIndex === 3 ? 'cur' : ''}`"
                @click="
                  changeRange({
                    rangeActiveIndex: 3,
                    PriceBegin: 10000,
                    PriceEnd: 20000,
                  })
                "
              >
                10K-20K
              </li>
              <li
                :class="`${rangeActiveIndex === 4 ? 'cur' : ''}`"
                @click="changeRange({ rangeActiveIndex: 4, PriceBegin: 20000 })"
              >
                20K+
              </li>
            </ul>
          </div>
        </div>
        <div class="pro-list">
          <ul class="fix">
            <router-link
              tag="li"
              v-for="item in proList"
              :key="item.Id"
              :to="`/commodity/detail?Id=${item.Id}`"
            >
              <div class="pic-box">
                <img :src="item.ImageUrl" :alt="item.Name" />
              </div>
              <div class="text-box">
                <p class="el">{{ item.Name }}</p>
                <div class="price">
                  <span class="price-new">{{ item.Price }}积分</span>
                  <span class="price-old" v-if="item.OldPrice"
                    >{{ item.OldPrice }}积分</span
                  >
                </div>
              </div>
            </router-link>
          </ul>
          <div class="page-num fix">
            <Page
              class="r"
              :current="PageIndex"
              :size="PageSize"
              :total="total"
              @on-change="changePage"
            ></Page>
          </div>
        </div>
      </div>
    </div>
    <Loading :loading="loading"></Loading>
		<ShopPopup />
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import axios from "@/libs/api.request";
import ShopRec from "@/components/shop-rec/";
import SingleBanner from "@/components/single-banner";
import Page from "@/components/page";
import { mapMutations } from "vuex";
import Loading from "@/components/loading";
import ShopPopup from '@/components/shop/ShopPopup.vue';

export default {
  name: "shopIndex",
  components: {
    ShopRec,
    SingleBanner,
    Page,
    Loading,
    ShopPopup,
  },
  data: () => {
    return {
      customerInfo: {},
      userLevel: 0,
      isMember: true, // 是否是会员
      signInFlag: "",
      signTip: "每日签到",
      isSignIn: false,
      currentIntegral: 0,
      obtainPoint: 0,
      shopRec: [],
      bannerList: [],
      typeActiveIndex: 0,
      rangeActiveIndex: 0,
      proList: [],
      GiftType: "", // 10虚拟，20实物，30轮船折扣券，不传表示全部
      PriceBegin: "", // 价格范围起始，不传表示没有最小限制
      PriceEnd: "", // 价格范围结束，不传表示没有最大限制
      PageIndex: 1,
      PageSize: 16,
      total: 0,
      loading: false,
      isFixed: false,
      limitedPromotionNO: null,
      continuousSigInDays:''
    };
  },
  created(){
    this.limitedPromotionNO = this.$route.query.lpno;
  },
  mounted() {
    this.loading = true;
    this.checkCustomerInfo().then((res) => {
      if (!res) {
        let href = window.location.href;
        window.location.href = `/Rccl.UserCenter/CustomerInfo/SignUpReward?returnUrl=${encodeURIComponent(
          href
        )}`;
      }
    });

    this.getUserLevelPrivilege().then((res) => {
      this.customerInfo = res.customerInfo;
      this.userLevel = this.getLevel(this.customerInfo.userLevel);
      this.isMember = !!res.privilegeList;

      // 存储信息
      this.storeInfo(res.customerInfo);
      this.storePrivilegeList(res.privilegeList);
    });
    this.getUserMobile().then((res) => {
      if (!this.customerInfo.fullName) {
        this.customerInfo.fullName = res.mobile;
        this.customerInfo = Object.assign({}, this.customerInfo);
        // 存储信息
        this.storeInfo(this.customerInfo);
      }
    });
    this.getUserSignIn().then((res) => {
      this.signInStatus = res.signInStatus;
      if (this.signInStatus === 1) {
        this.signInFlag = "cur";
        this.getSignInCount().then((res)=>{
          this.continuousSigInDays = res
        })
      }
    });
    this.getBanner("ProductListPageBanner_pc").then((res) => {
      this.bannerList = this.sortBanner(res.PictureModels);
    });
    this.getVipRecommend().then((res) => {
      this.shopRec = res.rows;
    });
    this.infiniteHandler().then((res) => {
      this.proList = res.data.rows;
      this.total = res.data.totalNum;
      this.loading = false;
      if(this.limitedPromotionNO !== '' && this.limitedPromotionNO !== null && this.limitedPromotionNO !== undefined && this.proList.length === 0) {
        this.$alert.show(this.limitedPromotionNO === 'A322' ? '活动暂未开始' : '活动已结束')
      }
    });
    window.addEventListener("scroll", this.initHeight, false);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.initHeight, false);
  },
  methods: {
    ...mapMutations(["storeInfo", "storePrivilegeList"]),
    initHeight() {
      this.offsetTop = document.querySelector(".part-pro").offsetTop;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.isFixed = scrollTop > this.offsetTop;
    },
    signIn() {
      if (this.signInStatus) return false;
      this.updatePoint(10002).then((res) => {
        this.signInStatus = 1;
        this.isSignIn = true;
        this.signInFlag = "cur";
        this.getSignInCount().then((res)=>{
          this.continuousSigInDays = res
        })
        this.currentIntegral += res ? res : 1;
        this.obtainPoint = res ? res : 1;
      });
    },
    closeSignIn() {
      this.isSignIn = false;
    },
    updatePoint(point) {
      return this.updateUserPoint(point);
    },
    getLevel(userLevelText) {
      switch (userLevelText) {
        case "初级会员":
          return 1;
        case "高级会员":
          return 2;
        case "精英会员":
          return 3;
        case "卓越会员":
          return 4;
      }
    },
    changePage(page) {
      this.PageIndex = page;
      this.loading = true;
      this.infiniteHandler().then((res) => {
        this.proList = res.data.rows;
        this.loading = false;
        if(this.limitedPromotionNO !== '' && this.limitedPromotionNO !== null && this.limitedPromotionNO !== undefined && this.proList.length === 0) {
          this.$alert.show(this.limitedPromotionNO === 'A322' ? '活动暂未开始' : '活动已结束')
        }
      });
    },
    getUserLevelPrivilege() {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/api/CustomerInfo/ApiGetUserLevelPrivilege",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: {
              loyaltyId: this.$store.state.user.loyaltyId,
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              resolve(data.data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    getUserMobile() {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/Rccl.OpenApi/User/GetUserPoint",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: {
              loyaltyId: this.$store.state.user.loyaltyId,
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.success) {
              resolve(data.data);
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    getUserSignIn() {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/api/CustomerInfo/ApiGetUserSignIn",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: {
              loyaltyId: this.$store.state.user.loyaltyId,
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              resolve(data.data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    updateUserPoint(pointCode) {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/api/CustomerInfo/ApiUpdateUserPoint",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: {
              pointCode,
              loyaltyId: this.$store.state.user.loyaltyId,
              changeChannel: "mobile",
            },
          })
          .then((res) => {
            let data = res.data;
            this.getSignInCount().then((res)=>{
              this.continuousSigInDays = res
            })
            if (data.errCode === 0) {
              resolve(data.data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    getVipRecommend() {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/pro/Store/CMProduct/GetVipRecommend",
            method: "get",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            params: {
              v: new Date().getTime(),
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              resolve(data.data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    getBanner(name) {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/pro/Store/CMCommon/GetBannerByName",
            method: "get",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            params: {
              name,
              v: new Date().getTime(),
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              resolve(data.data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    sortBanner(pics) {
      return pics.sort((itemA, itemB) => {
        return itemB.DisplayOrder - itemA.DisplayOrder;
      });
    },
    infiniteHandler() {
      let params = {
        GiftType: this.GiftType,
        PriceBegin: this.PriceBegin,
        PriceEnd: this.PriceEnd,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize
      }
      if(this.limitedPromotionNO !== '' && this.limitedPromotionNO !== null && this.limitedPromotionNO !== undefined) {
        params = Object.assign({
          LimitedPromotionNO: this.limitedPromotionNO
        },params)
      }
      return new Promise((resolve) => {
        axios
          .request({
            url: "/pro/Store/CMProduct/Search",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: params
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              resolve(data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    changeType({ typeActiveIndex, GiftType }) {
      this.typeActiveIndex = typeActiveIndex;
      this.GiftType = GiftType;
      this.PageIndex = 1;
      this.total = 0;
      this.proList = [];
      this.loading = true;
      this.infiniteHandler().then((res) => {
        this.proList = res.data.rows;
        this.total = res.data.totalNum;
        this.loading = false;
        if(this.limitedPromotionNO !== '' && this.limitedPromotionNO !== null && this.limitedPromotionNO !== undefined && this.proList.length === 0) {
          this.$alert.show(this.limitedPromotionNO === 'A322' ? '活动暂未开始' : '活动已结束')
        }
      });
    },
    changeRange({ rangeActiveIndex, PriceBegin, PriceEnd }) {
      this.rangeActiveIndex = rangeActiveIndex;
      this.PriceBegin = PriceBegin;
      this.PriceEnd = PriceEnd;
      this.PageIndex = 1;
      this.total = 0;
      this.proList = [];
      this.loading = true;
      this.infiniteHandler().then((res) => {
        this.proList = res.data.rows;
        this.total = res.data.totalNum;
        this.loading = false;
      });
    },
    checkCustomerInfo() {
      return new Promise((resolve) => {
        axios
          .request({
            url: "/api/CustomerInfo/ApiCheckCustomerInfo",
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.user.token}`,
            },
            data: {
              loyaltyId: this.$store.state.user.loyaltyId,
            },
          })
          .then((res) => {
            let data = res.data;
            if (data.errCode === 0) {
              resolve(data.data);
            } else if (data.errCode === 1000) {
              window.console.log("失败");
            } else {
              window.console.log("系统错误");
            }
          })
          .catch((err) => {
            window.console.log(err);
          });
      });
    },
    async getSignInCount(){
      return new Promise((resolve) => {
        axios
            .request({
              url: "/api/CustomerInfo/ApiGetUserSignInCnt",
              method: "post",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.$store.state.user.token}`,
              },
              data: {
                loyaltyId: this.$store.state.user.loyaltyId,
              },
            })
            .then((res) => {
              let data = res.data;
              if (data.errCode === 0) {
                this.continuousSigInDays = data.data.continuousSignInCnt
                resolve(data.data.continuousSignInCnt);
              } else if (data.errCode === 1000) {
                window.console.log("失败");
              } else {
                window.console.log("系统错误");
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.member-shop {
  padding-bottom: 84px;
  .info-card {
    height: 106px;
    padding-top: 14px;
    background-color: #fff;
    .user-level {
      width: 290px;
      padding-left: 22px;
      .icon {
        display: block;
        width: 78px;
        height: 78px;
      }
      .rank-text {
        padding-left: 15px;
        padding-top: 10px;
        .wel-text {
          line-height: 18px;
        }
        h3 {
          display: inline-block;
          vertical-align: middle;
          font-size: 26px;
          line-height: 36px;
        }
      }
    }
    .user-points {
      padding-top: 10px;
      .integral {
        position: relative;
        height: 23px;
        .icon-integral {
          width: 18px;
          height: 18px;
          background: url("../../../assets/images/icon_integral.png") no-repeat;
          background-size: cover;
        }
        .text {
          margin-left: 3px;
          line-height: 20px;
        }
        .num {
          position: absolute;
          left: 77px;
          top: 0;
          margin-top: -9px;
          margin-left: 4px;
          color: #ffa70d;
          font-size: 30px;
          font-weight: bold;
          line-height: 32px;
        }
      }
      .btn-box {
        .btn-integral {
          width: 134px;
          height: 34px;
          background: url("../../../assets/images/btn_intrgral.png") no-repeat;
          color: #fff;
          font-size: 16px;
          line-height: 34px;
          text-align: center;
          &.cur {
            background-image: url("../../../assets/images/btn_intrgral_cur.png");
            pointer-events: none;
          }
        }
        .e-vip {
          padding-left: 10px;
          .btn-vip {
            width: 240px;
            height: 34px;
            border: #0073bb solid 1px;
            border-radius: 17px;
            color: #0073bb;
            text-align: center;
            line-height: 33px;
            font-size: 16px;
            letter-spacing: 2px;
            .cur {
              font-weight: bold;
              i {
                position: relative;
                top: 1px;
                font-size: 18px;
              }
            }
          }
        }
      }
      .sign-in-layer {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 100;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        .sign-in {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 506px;
          height: 323px;
          margin-left: -132px;
          margin-top: -162px;
          padding-top: 30px;
          background: url("../../../assets/images/sign_in_bg.png") no-repeat;
          text-align: center;
          color: #fff;
          p {
            font-size: 30px;
            line-height: 40px;
          }
          h3 {
            display: block;
            height: 42px;
            font-size: 24px;
            font-weight: normal;
            line-height: 42px;
            i {
              margin-right: 8px;
            }
            .cur {
              position: relative;
              top: 4px;
              margin-right: 10px;
              font-size: 48px;
            }
          }
          .btn-close {
            position: absolute;
            left: 50%;
            bottom: -62px;
            width: 46px;
            height: 46px;
            margin-left: -23px;
            background: url("../../../assets/images/btn_close.png") no-repeat;
            background-size: cover;
          }
        }
      }
    }
    .link-aside {
      position: relative;
      width: 160px;
      height: 78px;
      padding-top: 12px;
      padding-right: 12px;
      text-align: center;
      &::before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: 50%;
        width: 1px;
        height: 84px;
        margin-top: -42px;
        background-color: #d3dadd;
      }
      .link-item {
        display: block;
        height: 20px;
        color: #0073bb;
        &:last-child {
          margin-top: 15px;
        }
        span {
          display: inline-block;
          vertical-align: middle;
          margin-right: 5px;
        }
      }
      .icon {
        display: inline-block;
        vertical-align: middle;
        width: 20px;
        height: 20px;
        &.icon-list {
          background: url("../../../assets/images/icon_list.png");
        }
        &.icon-gift {
          background: url("../../../assets/images/icon_gift.png");
        }
      }
    }
    &.member-01 {
      .icon-member {
        background: url("../../../assets/images/member_01.png");
      }
      .rank-text {
        h3 {
          color: #3a5d9b;
        }
      }
    }
    &.member-02 {
      .icon-member {
        background: url("../../../assets/images/member_02.png");
      }
      .rank-text {
        h3 {
          color: #5c6376;
        }
      }
    }
    &.member-03 {
      .icon-member {
        background: url("../../../assets/images/member_03.png");
      }
      .rank-text {
        h3 {
          color: #8e5543;
        }
      }
    }
    &.member-04 {
      .icon-member {
        background: url("../../../assets/images/member_04.png");
      }
      .rank-text {
        h3 {
          color: #a78856;
        }
      }
    }
    .person-info {
      .user-level {
        width: auto;
        .icon-member-00 {
          background: url("../../../assets/images/loginLogo_00.png");
          background-size: 100% 100%;
        }
        .rank-text {
          padding-top: 13px;
          .integral {
            padding-top: 14px;
            .icon-integral {
              width: 18px;
              height: 18px;
              background: url("../../../assets/images/icon_integral.png")
                no-repeat;
              background-size: cover;
            }
            .text {
              margin-left: 3px;
              line-height: 18px;
            }
            .num {
              margin-top: -12px;
              margin-left: 4px;
              color: #ffa70d;
              font-size: 30px;
              font-weight: bold;
            }
          }
        }
      }
      .member-tip {
        padding-top: 31px;
        padding-left: 10px;
        .btn-join {
          width: 134px;
          height: 34px;
          background-color: #fbc500;
          border-radius: 17px;
          font-size: 16px;
          line-height: 34px;
          text-align: center;
        }
        .join-tip {
          padding-left: 10px;
          color: #747d80;
          line-height: 16px;
          .cur {
            color: #ffa70d;
            font-weight: bold;
          }
        }
      }
    }
  }
  .part-pro {
    padding-top: 19px;
    .pro-select-wrap {
      height: 123px;
    }
    .pro-select {
      width: 950px;
      background-color: #f5f5f5;
      &.fixed {
        position: fixed;
        left: 50%;
        top: 0;
        z-index: 9;
        margin-left: -350px;
      }
      .sort-type {
        li {
          float: left;
          width: 164px;
          height: 56px;
          background-color: #f3f6f8;
          border-top: #d3dadd solid 1px;
          border-left: #d3dadd solid 1px;
          text-align: center;
          font-size: 18px;
          line-height: 56px;
          cursor: pointer;
          &:last-child {
            border-right: #d3dadd solid 1px;
          }
          &.cur {
            background-color: #fff;
            border-top: #4a90e2 solid 3px;
            font-size: 20px;
            color: #4a90e2;
            font-weight: bold;
            line-height: 53px;
          }
        }
      }
      .sort-integral {
        height: 67px;
        padding-top: 21px;
        padding-left: 27px;
        background-color: #fff;
        border: #d3dadd solid 1px;
        li {
          float: left;
          width: 100px;
          height: 26px;
          margin-right: 20px;
          border-radius: 13px;
          background-color: #eff2f5;
          line-height: 26px;
          text-align: center;
          cursor: pointer;
          &.cur {
            background-color: #4a90e2;
            color: #fff;
          }
        }
      }
    }
    .pro-list {
      padding-top: 10px;
      ul {
        width: 970px;
        li {
          float: left;
          width: 230px;
          height: 220px;
          padding: 10px;
          margin-right: 10px;
          margin-bottom: 10px;
          background-color: #fff;
          border: #d4dbde solid 1px;
          border-radius: 0.06rem;
          cursor: pointer;
          .pic-box {
            position: relative;
            width: 100%;
            height: 133px;
            background-color: #f7f7f7;
            overflow: hidden;
            img {
              display: block;
              position: absolute;
              left: 0;
              top: 50%;
              width: 100%;
              transform: translateY(-50%);
              -webkit-transform: translateY(-50%);
              -moz-transform: translateY(-50%);
              -o-transform: translateY(-50%);
              -ms-transform: translateY(-50%);
            }
          }
          .text-box {
            padding-top: 10px;
            p {
              line-height: 23px;
              font-size: 16px;
            }
            .price-new {
              font-size: 16px;
              color: #ffa70d;
              line-height: 28px;
            }
            .price-old {
              padding-left: 8px;
              font-size: 14px;
              color: #747d80;
              line-height: 28px;
              text-decoration: line-through;
            }
          }
          &:hover {
            border: #ffa70d solid 2px;
            padding: 9px;
          }
        }
      }
    }
  }
  .page-num {
    padding-top: 21px;
  }
}
</style>
